module.exports = __webpack_public_path__ + "img/zfb.6ebbd900.png";